import { Link } from "react-router-dom";
import logoImg from "@/assets/main-logo.svg";

const PastaLogo = ({ size = "md", className = "", onClick }: { size?: "sm" | "md" | "lg"; className?: string; onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void }) => {
  const heights = {
    sm: "h-10 sm:h-14 lg:h-20",
    md: "h-16 sm:h-20",
    lg: "h-20 sm:h-24",
  };

  return (
    <Link to="/" onClick={onClick} className="select-none no-underline block" dir="ltr">
      <img
        src={logoImg}
        alt="PastaLuna"
        className={`${heights[size]} w-auto object-contain`}
      />
    </Link>
  );
};

export default PastaLogo;
